import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Formik } from "formik";
import * as Yup from "yup";

import { createTag } from "src/api/settings";
import { TextField } from "src/components/form";
import { Button } from "src/components/ui/button";
import { usePortalContext } from "src/context/PortalContext";
import { showSuccessToast } from "src/lib/utils";

const validationSchema = Yup.object().shape({
	name: Yup.string().required("Tag name is required"),
});

const NewTagModal = () => {
	const closePortal = usePortalContext();
	const queryClient = useQueryClient();

	const { mutate, isLoading } = useMutation(createTag, {
		onSuccess: () => {
			showSuccessToast("Tag created successfully");
			queryClient.invalidateQueries(["tags"]);
			closePortal();
		},
	});

	return (
		<Formik initialValues={{ name: "" }} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
			{({ values, handleChange, handleSubmit, errors, touched }) => (
				<form onSubmit={handleSubmit} className="tw-grid tw-gap-4">
					<TextField
						label="Tag name"
						name="name"
						placeholder="Tag name"
						value={values.name}
						error={touched.name && errors.name}
						onChange={handleChange}
						required
					/>

					<Button type="submit" variant="secondary" className="tw-w-full" disabled={isLoading}>
						{isLoading ? "Adding..." : "Add tag"}
					</Button>
				</form>
			)}
		</Formik>
	);
};

export default NewTagModal;
